import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ActivityButton from "../baseElements/ActivityButton";
import { useNavigate } from 'react-router-dom';
import { useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { AppContext } from "../AppContext";
import { checkActivityStatus, getLog, redirectToExercise, saveLogToDB } from "../ActivityManager";
import Spinner from "react-bootstrap/Spinner";

axios.defaults.withCredentials = true;

function HomePage() {
    const navigate = useNavigate();
    const { setActivityList, setCurrentActivity, logout } = useContext(AppContext);
    const [isMdOrLess, setIsMdOrLess] = useState(window.innerWidth <= 768);
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(true);
    
    function resetStates() {
        setActivityList([]);
        setCurrentActivity(-1);
    }
    
    useEffect(() => {
        window.history.pushState(null, '', window.location.href);
        
        window.onpopstate = (event) => {
            event.preventDefault();
            navigate('/');
        };
        
        return () => {
            window.onpopstate = null;
        };
    }, [navigate]);
    
    useEffect(() => {
        resetStates();
        loadActivities().then(() => setLoading(false));
    }, [navigate]);
    
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    
    const handleResize = () => {
        setIsMdOrLess(window.innerWidth < 768);
    };
    
    function getRandomColor() {
        const colors = ["purple", "green", "pink", "blue"];
        const randomIndex = Math.floor(Math.random() * colors.length);
        return colors[randomIndex];
    }
    
    const loadActivities = async () => {
        const axiosConfig = {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json'
            }
        };
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/patientActivities`, axiosConfig);
            if (response.data.success) {
                const temp = [];
                for (const activity of response.data.data) {
                    const exercises_response = await axios.post(`${process.env.REACT_APP_API_URL}/api/getActivityExercises`, { activity_id: activity[0] }, axiosConfig);
                    const log = await getLog(activity[0]);
                    const exercises = exercises_response.data.data;
                    
                    let total = 0;
                    let count = 0;
                    
                    if (log.data[0] === null) {
                        await uploadInitialLog(exercises, activity[0]);
                        count = 0;
                        total = exercises.length;
                    } else {
                        const actions = JSON.parse(JSON.stringify(activity[2]));
                        actions.forEach((action) => {
                            if (action.progress === 100) count++;
                            total++;
                        });
                    }
                    
                    const percentage = Math.round((count / total) * 100);
                    temp.push({ id: activity[0], name: activity[1], color: getRandomColor(), progress: percentage });
                }
                setActivities(temp);
            } else {
                console.log(response.data.errorMess);
            }
        } catch (error) {
            console.log(error);
        }
    };
    
    async function uploadInitialLog(exercises, activityId) {
        let initialLog = [];
        exercises.forEach((exercise) => {
            initialLog.push({ exercise_id: exercise[0], exercise_type: exercise[1], progress: 0, actions: [] });
        });
        await saveLogToDB(activityId, initialLog);
    }
    
    /*
    async function resetActivities() {
        const axiosConfig = {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json'
            }
        }
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/patientActivities`, axiosConfig);
            if (response.data.success) {
                const temp = [];
                for (const activity of response.data.data) {
                    const exercises_response = await axios.post(`${process.env.REACT_APP_API_URL}/api/getActivityExercises`, { activity_id: activity[0] }, axiosConfig);
                    const exercises = exercises_response.data.data;
                    
                    await uploadInitialLog(exercises, activity[0]);
                    
                    temp.push({ id: activity[0], name: activity[1], color: getRandomColor(), progress: 0 });
                }
                setActivities(temp);
            } else {
                console.log(response.data.errorMess);
            }
        } catch (error) {
            console.log(error);
        }
    }
    */
    
    const startActivityExercises = async (activityId) => {
        const axiosConfig = {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json'
            }
        };
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/getActivityExercises`, { activity_id: activityId }, axiosConfig);
            if (response.data.success) {
                const exercises = response.data.data;
                setCurrentActivity(activityId);
                
                checkActivityStatus(activityId, exercises).then(
                    (response) => {
                        try {
                            setActivityList(response);
                            redirectToExercise(response, navigate);
                        } catch (error) {
                            console.log(error);
                        }
                    }
                );
            } else {
                console.log(response.data.errorMess);
            }
        } catch (error) {
            console.log(error);
        }
    };
    
    const handleLogout = async () => {
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/api/logout?role=patient`, {}, {
                withCredentials: true,
                headers: { 'Content-Type': 'application/json' }
            });
        } catch (err) {
            console.warn("Logout API call failed:", err);
        }
        
        logout(); // Clears frontend state
        navigate('/login'); // Safer than navigating to '/'
    };
    
    return (
        <div className={'container-fluid ' + (isMdOrLess ? 'smallLoginBackground' : 'homeBackground')}>
            <div className='logout-button' onClick={handleLogout}>
                Logout
            </div>
            <div className='activitiesContainer'>
                <div className="activitiesInfo">
                    <h2 className='activityText'>Le tue attività</h2>
                </div>
                {loading ? (
                    <div className="activitiesSpinnerContainer">
                        <Spinner animation="border" style={{ width: '5rem', height: '5rem' }} />
                    </div>
                ) : (
                    <div className='activitiesGrid'>
                        {activities.map((activity, index) => activity.progress !== 100 && (
                            <ActivityButton
                                key={index}
                                color={activity.color}
                                progress={activity.progress}
                                name={activity.name}
                                onClick={() => startActivityExercises(activity.id)}
                            />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default HomePage;